import { channel } from 'redux-saga';
export const purchaseEventsChannel = channel();
export function isNFTPurchase(purchase) {
    return 'nft' in purchase;
}
export function isManaPurchase(purchase) {
    return !isNFTPurchase(purchase);
}
//# sourceMappingURL=utils.js.map